import firebase from 'firebase';
import 'firebase/firestore';
export var config = {
    apiKey: process.env.FIREBASE_API_KEY,
    authDomain: process.env.FIREBASE_AUTH_DOMAIN,
    databaseURL: process.env.FIREBASE_DATABASE_URL,
    projectId: process.env.FIREBASE_PROJECT_ID,
};
var firebaseApp = firebase.initializeApp(config);
export var db = firebaseApp.database();
export var fs = firebaseApp.firestore();



//////////////////
// WEBPACK FOOTER
// ./src/services/firebase.ts
// module id = 114
// module chunks = 1